import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

import { SpecialtyCertificationTableFilterSchema } from '../../../-components/SpecialtyCertificationList/-zod-schema';

export const Route = createFileRoute(
  '/_staff/certification/$id/_layout/specialty-certifications/',
)({
  validateSearch: zodValidator(SpecialtyCertificationTableFilterSchema),
});
